import * as React from "react";
import { TabsList, TabsTrigger } from "@/components/ui/tabs";
import { MACHINE_SIDEBAR_TAB_ICONS } from "../tabs-config";

function renderIcon(tabId: string): React.ReactNode {
  const cfg = MACHINE_SIDEBAR_TAB_ICONS[tabId];
  if (!cfg) return null;
  const Icon = cfg.icon;
  return <Icon className="h-4 w-4" />;
}

interface TabsRailProps {
  compactRail: boolean;
  dirtyTabs: Set<string>;
  showConfigTabs: boolean;
  configTabsDisabled: boolean;
  isDraft?: boolean;
}

function triggerLabel(id: string, fallback?: string): string {
  return MACHINE_SIDEBAR_TAB_ICONS[id]?.label ?? fallback ?? id;
}

export function TabsRail({
  compactRail,
  dirtyTabs,
  showConfigTabs,
  configTabsDisabled,
  isDraft = false,
}: TabsRailProps): React.ReactElement {
  return (
    <TabsList
      orientation="vertical"
      compact={compactRail}
      className=""
      aria-label="Seções da máquina"
    >
      <TabsTrigger
        value="basic"
        dirty={dirtyTabs.has("basic")}
        icon={renderIcon("basic")}
        label={triggerLabel("basic")}
      />
      {showConfigTabs ? (
        <TabsTrigger
          value="parameters"
          dirty={dirtyTabs.has("parameters")}
          disabled={configTabsDisabled}
          title={configTabsDisabled ? "Salve os dados básicos primeiro." : undefined}
          icon={renderIcon("parameters")}
          label={triggerLabel("parameters")}
        />
      ) : null}
      <TabsTrigger
        value="sensors"
        dirty={dirtyTabs.has("sensors")}
        icon={renderIcon("sensors")}
        label={triggerLabel("sensors")}
      />
      {showConfigTabs ? (
        <TabsTrigger
          value="compatibilities"
          dirty={dirtyTabs.has("compatibilities")}
          disabled={configTabsDisabled}
          title={configTabsDisabled ? "Salve os dados básicos primeiro." : undefined}
          icon={renderIcon("compatibilities")}
          label={triggerLabel("compatibilities")}
        />
      ) : null}
      {!isDraft ? (
        <TabsTrigger
          value="alarms"
          dirty={dirtyTabs.has("alarms")}
          icon={renderIcon("alarms")}
          label={triggerLabel("alarms")}
        />
      ) : null}
      {!isDraft ? (
        <TabsTrigger
          value="operation"
          icon={renderIcon("operation")}
          label={triggerLabel("operation")}
        />
      ) : null}
      {showConfigTabs ? (
        <TabsTrigger
          value="advanced"
          disabled={configTabsDisabled}
          title={configTabsDisabled ? "Salve os dados básicos primeiro." : undefined}
          icon={renderIcon("advanced")}
          label={triggerLabel("advanced")}
        />
      ) : null}
    </TabsList>
  );
}
